<template>
  <div class="locale-changer">
    <select class="form-control-sm text-black-50 bg-light ml-2" v-model="$i18n.locale">
      <option value="pt_BR">Português</option>
      <option value="en_US">English</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'locale-changer',
  data () {
    return { langs: ['pt_BR', 'en_US'] }
  }
}
</script>
